import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const EverydayLapses = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >

        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">

          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-12">

            {/* left text */}
            {/* <div className="text-left max-w-2xl"> */}
            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              EVERYDAY LAPSES
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6 text-center"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Why did I walk into this room?
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">

            <div className="grid lg:grid-cols-2 gap-12 items-start">

              {/* Left Column */}
              <div className="max-w-2xl">

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  You walk upstairs with a purpose. Halfway there, you forget what it was.
                  You put your glasses down somewhere "safe" and spend the next twenty
                  minutes looking for them. You arrive at the supermarket and can't
                  remember the one item you specifically came to buy. You reread the same
                  paragraph three times. You call your son by the dog's name. Or worse,
                  the dog by your son's name.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Sound familiar? Most of us experience dozens of these little cognitive
                  lapses every week. We often blame our memory, but neuroscience suggests
                  something rather different. In many cases, memory isn't the problem at
                  all — attention is.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  The human brain is an extraordinary machine, but it has a fundamental
                  limitation: it can only focus on a tiny fraction of the information
                  available to it at any moment. Executive function solves this problem by
                  directing an attentional spotlight toward what seems most important.
                  Usually, that works brilliantly. But sometimes, it works a little too
                  well.
                </p>

              </div>

              {/* right image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/everyday-lapses.png"
                  alt="Everyday Lapses"
                  className="w-full max-w-[600px]"
                />
              </div>

            </div>

            {/* Full Width Text */}
            <div className="mt-2">




              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you'll discover why everyday lapses
                happen to all of us, what they reveal about the hidden workings of
                executive function, why attention is both your brain's greatest strength
                and greatest weakness, and how sleep, stress, mindfulness, and simple
                habits can dramatically influence your ability to stay mentally on track.
                The big question isn't why you occasionally forget where you left your
                keys — it's how your brain manages to find them again.
              </p>

              {/* Creyos Test Button */}
              <div className="mt-12 text-center">
                <a
                  href="https://habstudy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                >
                  IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE, CLICK HERE
                </a>
              </div>
            </div>



          </div>

        </div>

        {/* <div className="relative w-full max-w-[650px]">

        <img
          src="/transparent-ai-image.png"
          alt="ai image"
          className="w-full"
        />

      </div> */}

      </section >
    </div >
  );
};

export default EverydayLapses;